import * as Sentry from '@sentry/remix';
import { useEffect, useRef, useState } from 'react';

import useUser from '~/hooks/useUser';
import brazeClient from '~/services/braze.client';

interface Props {
  placementId: string;
}

export default function BrazeBanner({ placementId }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [hasBanner, setHasBanner] = useState(false);
  const user = useUser();

  useEffect(() => {
    if (!user.isLoggedIn) return;
    if (!containerRef.current) return;

    try {
      brazeClient.init();

      const existingBanner = brazeClient.getBanner(placementId);

      if (existingBanner) {
        brazeClient.insertBanner(existingBanner, containerRef.current);

        return setHasBanner(true);
      }

      brazeClient.subscribeToBannersUpdates(() => {
        const banner = brazeClient.getBanner(placementId);

        if (banner && containerRef.current) {
          brazeClient.insertBanner(banner, containerRef.current);
          setHasBanner(true);
        }
      });

      brazeClient.requestBannersRefresh([placementId]);
    } catch (error) {
      Sentry.captureException(error);
    }
  }, [placementId, user.isLoggedIn]);

  return (
    <div
      ref={containerRef}
      className={`col-span-full w-full [&_iframe]:block [&_iframe]:w-full ${hasBanner ? 'block' : 'hidden'}`}
      suppressHydrationWarning
    />
  );
}
